import React from 'react'
import { graphql } from 'gatsby'
import { Offer } from './mapper'
import MapWithPlaceholder from '../../ui/mapWithPlaceholder'

type OfferMapProps = {
  data: Offer
  apiKey?: string | null
}

const OfferMap: React.FC<OfferMapProps> = ({ data, apiKey = undefined }) => {
  const location = {
    latitude: data.office.lat ?? 0,
    longitude: data.office.lng ?? 0,
    street: data.office.street ?? '',
    city: data.office.cityForMap ?? '',
    postalCode: data.office.postalCode ?? '',
  }
  return (
    <div className="lg:mb-12">
      <MapWithPlaceholder locations={[location]} apiKey={apiKey} />
    </div>
  )
}

export default OfferMap

export const query = graphql`
  fragment OfferMap on STRAPI_ACCOUNTING_OFFICE {
    latitude
    longitude
    name
    street
    postalCode
    city
  }
`
